import React, { useState, useEffect } from 'react'

const PlayersPagination = props => {
  const [totalPages, setTotalPages] = useState(Math.ceil(props.totalCount / props.perPage))
  const pagesToEnd = totalPages - props.page

  const range = (start, end) => {
    return Array(end - start).fill().map((_, idx) => start + idx)
  }

  const previousPages = () => {
    if (props.page < 5) {
      return (
        range(1, props.page).map(page => (
          <a key={page} className='pagination-button' onClick={() => props.onPageChange(page)}>{page}</a>
        ))
      )
    } else {
      return (
        <div>
          <a className='pagination-button' onClick={() => props.onPageChange(1)}>1</a>
          <span>...</span>
          <a className='pagination-button' onClick={() => props.onPageChange(props.page - 1)}>{props.page - 1}</a>
        </div>
      )
    }
  }

  const nextPages = () => {
    if (pagesToEnd >= 5) {
      return (
        <div>
          <a className='pagination-button' onClick={() => props.onPageChange(props.page + 1)}>{props.page + 1}</a>
          <span>...</span>
          <a className='pagination-button' onClick={() => props.onPageChange(totalPages)}>{totalPages}</a>
        </div>
      )
    } else if (pagesToEnd != 0) {
      return (
        range(props.page + 1, totalPages + 1).map(page => (
          <a key={page} className='pagination-button' onClick={() => props.onPageChange(page)}>{page}</a>
        ))
      )
    }
  }

  const paginationInfo = () => {
    const from = props.totalCount < props.perPage ? 1 : (props.perPage * (props.page - 1)) + 1
    const to = props.page == totalPages ? props.totalCount : from + (props.perPage - 1)
    return (
      <span>
        Showing {from} to {to} of {props.totalCount} entries
      </span>
    )
  }

  useEffect(() => {
    const newPagesCount = Math.ceil(props.totalCount / props.perPage)
    if (newPagesCount !== totalPages) {
      setTotalPages(newPagesCount);
    }
  }, [props.totalCount, props.perPage])

  return (
    <div className='players-pagination'>
      <div className='info'>
        <select
          className='per-page-selector'
          value={props.perPage}
          onChange={e=> props.onPerPageChange(e.target.value)}>
          { [50,100,200,300,400].map((o, i) => <option key={i} value={o}>Show {o}</option>) }
        </select>&nbsp;
        {paginationInfo()}
      </div>
      <div className='players-pages'>
        { props.page >= 2 &&
          <a className='pagination-button' onClick={() => props.onPageChange(props.page - 1)}>previous</a>
        }
        {previousPages()}
        <a className='pagination-button current-page'>{props.page}</a>
        {nextPages()}
        { pagesToEnd >= 1 &&
          <a className='pagination-button' onClick={() => props.onPageChange(props.page + 1)}>next</a>
        }
      </div>
    </div>
  )
}

export default PlayersPagination
